<legend>{{ 'tkey;dialplanmanagement.admin.group.writeldap.navlink' | translate }}</legend>

<ziro-custom-input-text fieldId="e164_ldap"></ziro-custom-input-text>
<ziro-custom-input-text fieldId="extension_ldap"></ziro-custom-input-text>
